"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[43981],{

/***/ 43981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ tabs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.js + 1 modules
var tabs_tabs = __webpack_require__(49808);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./lib/utils/utils.ts
var utils = __webpack_require__(622);
;// CONCATENATED MODULE: ./components/molecules/tabs/Tabs.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                text-button w-full py-2 text-primary-500 focus:ring-0 focus:ring-offset-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 md:min-w-[120px]\n                ",
        "\n              "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





/**
 * TabGroup
 */ const Tabs = (param)=>/*#__PURE__*/ {
    let { classNameTabs , children , tabs , unmount =false  } = param;
    return (0,jsx_runtime/* jsx */.tZ)(tabs_tabs/* Tab.Group */.O.Group, {
        as: compat_module.Fragment,
        children: (param)=>/*#__PURE__*/ {
            let { selectedIndex  } = param;
            return (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tabs_tabs/* Tab.List */.O.List, {
                        className: "mx-auto flex w-full justify-center overflow-x-auto rounded-lg bg-neutrals-100 p-1 ".concat(classNameTabs),
                        children: tabs.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tabs_tabs/* Tab */.O, {
                                className: (0,es/* oneLine */.f9)(_templateObject(), selectedIndex === index ? "transition-color rounded bg-primary-500 text-neutrals-50 duration-150" : ""),
                                children: item
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tabs_tabs/* Tab.Panels */.O.Panels, {
                        className: "mt-4 w-full",
                        children: (0,utils/* toArray */.qo)(children).filter(Boolean).map((child, index)=>/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tabs_tabs/* Tab.Panel */.O.Panel, {
                                unmount: unmount,
                                children: child
                            }, index))
                    })
                ]
            });
        }
    });
};
Tabs.displayName = "Tabs";

;// CONCATENATED MODULE: ./components/molecules/tabs/index.ts

/* harmony default export */ var tabs = (Tabs);


/***/ })

}]);